<div *ngIf="speed">
  <mat-icon [matBadge]="speed.effectiveType" [matBadgeColor]="speed.semaforo" [matTooltip]="'Tu conexión es de: '+ speed.downlink+'Mbps'" >{{Icons.WIFI}}</mat-icon>
</div>
<div *ngIf="!speed">
  <mat-icon matBadge="..." matBadgeColor="accent">{{Icons.WIFI}}</mat-icon>
</div>

